// SEO Configuration for all pages

const baseUrl = 'https://www.bloomcycleinnovations.in';
const defaultImage = `${baseUrl}/BLOOMCYCLE_INNOVATIONS-removebg-preview.webp`;

export const seoConfig = {
  home: {
    title: 'BloomCycle Innovations – Biochar, Carbon Removal & MRV for Farmers',
    description: 'BloomCycle Innovations enables farmers to earn from biochar-based carbon removal with MRV, IoT soil monitoring, blockchain tracking, and biomass valorization.',
    canonical: `${baseUrl}/`,
    ogTitle: 'BloomCycle – Transforming Agriculture with Carbon Removal',
    ogDescription: 'MRV-verified biochar production, IoT-based soil insights, satellite monitoring, and farmer carbon credit systems.',
    ogImage: defaultImage,
    twitterTitle: 'BloomCycle – Transforming Agriculture with Carbon Removal',
    twitterDescription: 'MRV-verified biochar production, IoT-based soil insights, satellite monitoring, and farmer carbon credit systems.',
    twitterImage: defaultImage,
  },
  farmers: {
    title: 'Earn Carbon Revenue with BloomCycle – Join as a Farmer',
    description: 'Farmers can earn more income by supplying crop residue for biochar production. Join BloomCycle\'s climate-smart program with IoT soil sensors and MRV-backed carbon credits.',
    canonical: `${baseUrl}/farmers`,
    ogTitle: 'Join BloomCycle – Earn Through Carbon Credits',
    ogDescription: 'Turn crop residue into income. Get soil insights, carbon credit benefits, and sustainable farming solutions.',
    ogImage: defaultImage,
    twitterTitle: 'Join BloomCycle – Earn Through Carbon Credits',
    twitterDescription: 'Turn crop residue into income. Get soil insights, carbon credit benefits, and sustainable farming solutions.',
    twitterImage: defaultImage,
  },
  technology: {
    title: 'BloomCycle Technology – Biochar Reactor, MRV, Satellite & Blockchain',
    description: 'Explore BloomCycle\'s state-of-art biochar reactor, satellite-based MRV, blockchain traceability, IoT soil data, and biomass-to-biochar technology for carbon removal.',
    canonical: `${baseUrl}/technology`,
    ogTitle: 'BloomCycle State-of-Art Carbon Removal Technology',
    ogDescription: 'Dual-kiln biochar reactor, satellite MRV, IoT soil systems, and blockchain-based carbon tracking.',
    ogImage: defaultImage,
    twitterTitle: 'BloomCycle State-of-Art Carbon Removal Technology',
    twitterDescription: 'Dual-kiln biochar reactor, satellite MRV, IoT soil systems, and blockchain-based carbon tracking.',
    twitterImage: defaultImage,
  },
  mrv: {
    title: 'MRV System – Satellite, IoT & Blockchain for Carbon Removal',
    description: 'BloomCycle\'s MRV integrates satellite NDVI, IoT sensors, geotagged farms, biomass tracking and blockchain logs. Fully compatible with VERRA VM0044.',
    canonical: `${baseUrl}/mrv`,
    ogTitle: 'BloomCycle MRV – Verified Carbon Removal System',
    ogDescription: 'Hybrid MRV with satellite verification, IoT soil data, geotagging and blockchain activity logs for trusted carbon credits.',
    ogImage: defaultImage,
    twitterTitle: 'BloomCycle MRV – Verified Carbon Removal System',
    twitterDescription: 'Hybrid MRV with satellite verification, IoT soil data, geotagging and blockchain activity logs for trusted carbon credits.',
    twitterImage: defaultImage,
  },
  biochar: {
    title: 'Premium Biochar – Soil Regeneration & Carbon Removal',
    description: 'High-quality biochar produced using optimized pyrolysis reactors. Enhances soil fertility and permanently sequesters carbon for 100+ years.',
    canonical: `${baseUrl}/biochar`,
    ogTitle: 'BloomCycle Biochar – Sustainable Soil Regeneration',
    ogDescription: 'Premium biochar for carbon sequestration, soil health improvement, and climate-smart agriculture.',
    ogImage: defaultImage,
    twitterTitle: 'BloomCycle Biochar – Sustainable Soil Regeneration',
    twitterDescription: 'Premium biochar for carbon sequestration, soil health improvement, and climate-smart agriculture.',
    twitterImage: defaultImage,
  },
  about: {
    title: 'About BloomCycle Innovations – Building India\'s Carbon Removal Future',
    description: 'BloomCycle Innovations is a climate-tech startup enabling MRV-integrated carbon removal through biochar, IoT, satellite monitoring and farmer partnerships.',
    canonical: `${baseUrl}/about`,
    ogTitle: 'About BloomCycle Innovations – Building India\'s Carbon Removal Future',
    ogDescription: 'Climate-tech startup enabling MRV-integrated carbon removal through biochar, IoT, satellite monitoring and farmer partnerships.',
    ogImage: defaultImage,
    twitterTitle: 'About BloomCycle Innovations – Building India\'s Carbon Removal Future',
    twitterDescription: 'Climate-tech startup enabling MRV-integrated carbon removal through biochar, IoT, satellite monitoring and farmer partnerships.',
    twitterImage: defaultImage,
  },
  contact: {
    title: 'Contact BloomCycle Innovations – Partner With Us',
    description: 'Contact BloomCycle for partnerships, carbon credit buyers, farmer onboarding, technology collaborations, and sustainability programs.',
    canonical: `${baseUrl}/contact`,
    ogTitle: 'Contact BloomCycle Innovations – Partner With Us',
    ogDescription: 'Contact BloomCycle for partnerships, carbon credit buyers, farmer onboarding, technology collaborations, and sustainability programs.',
    ogImage: defaultImage,
    twitterTitle: 'Contact BloomCycle Innovations – Partner With Us',
    twitterDescription: 'Contact BloomCycle for partnerships, carbon credit buyers, farmer onboarding, technology collaborations, and sustainability programs.',
    twitterImage: defaultImage,
  },
  privacy: {
    title: 'Privacy Policy – BloomCycle Innovations',
    description: 'BloomCycle Innovations privacy policy describing data collection, IoT sensor data usage, blockchain logs, and MRV protocol compliance.',
    canonical: `${baseUrl}/privacy`,
    ogTitle: 'Privacy Policy – BloomCycle Innovations',
    ogDescription: 'BloomCycle Innovations privacy policy describing data collection, IoT sensor data usage, blockchain logs, and MRV protocol compliance.',
    ogImage: defaultImage,
    twitterTitle: 'Privacy Policy – BloomCycle Innovations',
    twitterDescription: 'BloomCycle Innovations privacy policy describing data collection, IoT sensor data usage, blockchain logs, and MRV protocol compliance.',
    twitterImage: defaultImage,
  },
};

